import React from "react";
import { Row, Col } from "react-bootstrap";
import FinancialInfoCard from "./FinancialInfoCard";
import BatchInformationCard from "./BatchInformation";
import CliamsSummaryInfoCard from "./CliamsSummaryInfoCard";

const CliamsInformations = ({ totalRows, total, statusCounts }) => {
  return (
    <Col xl={12}>
      <CliamsSummaryInfoCard
        total={total}
        totalRows={totalRows}
        statusCounts={statusCounts}
      />
    </Col>
  );
};

export default CliamsInformations;
